enum storageKeys {
  bootcamp_hasModalBeenDisplayed = "hasBootcampModalBeenDisplayed",
  consent_PDCStatus = "consent_PDCStatus",
  courses_hasModalBeenDisplayed = "hasCoursesModalBeenDisplayed",
  courses_selectedTab = "courses_selectedTab",
  currentlySelectedSoundLibrary = "currentlySelectedSoundLibrary",
  dashboard_hasModalBeenDisplayed = "hasDashboardModalBeenDisplayed",
  displayedCourseModals = "displayedCourseModals",
  lessonPlayer_demoSoundActivatedPrompt_isAllowedByUser = "lessonPlayer_demoSoundActivatedPrompt_isAllowedByUser",
  lessonPlayer_demoSoundPrompt_isAllowedByUser = "lessonPlayer_demoSoundPrompt_isAllowedByUser",
  lessonPlayer_metrics_segmentOpenedCount = "lessonPlayer_metrics_segmentOpenedCount",
  lessonPlayer_notationSpacing = "lessonPlayer_notationSpacing",
  lessonPlayer_segmentsSettings = "segmentsSettings",
  lessonPlayer_switchToPitchDetectionPrompt_isAllowedByUser = "lessonPlayer_switchToPitchDetectionPrompt_isAllowedByUser",
  logging_enabledNamespaces = "debug",
  logging_global_showDataOnOneLine = "logging_global_showDataOnOneLine",
  logging_global_showStacks = "logging_global_showStacks",
  routing_lastLocationPathUsed = "lastLocationPathUsedLocalStorageKey",
  routing_lastPageRouteUsed = "lastPageRouteUsedLocalStorageKey",
  segmentPlayer_midiDeviceSettingsGroup = "segmentPlayer_midiDeviceSettingsGroup",
  segmentPlayer_pitchDetection_debugging_isEnabled = "segmentPlayer_pitchDetection_debugging_isEnabled",
  segmentPlayer_pitchDetection_hasDemoSoundEnabledWarningBeenDisplayed = "segmentPlayer_pitchDetection_hasDemoSoundEnabledWarningBeenDisplayed",
  segmentPlayer_pitchDetection_playbackRecording = "segmentPlayer_pitchDetection_playbackRecording",
  segmentPlayer_userPreferencesForControlBar = "userPreferencesForControlBar",
  settings_selectedMidiDeviceId = "currentlySelectedMidiDevice",
  settings_selectedMidiDeviceName = "currentlySelectedMidiDeviceName",
  settings_volumes = "volumes",
}

export default storageKeys;

